module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_JPWxNHL_Bottle_v2.f7ff014b.jpg";